module.exports = __webpack_public_path__ + "img/device-mobile.e54d1e64.svg";